import { Controller } from "@hotwired/stimulus";
import TomSelect from 'tom-select'
import "tom-select/dist/css/tom-select.default.css"

const updateInput: (input: HTMLInputElement) => void = (input) => {
  input.classList.toggle("has-content", input.value.length > 0 || input.type === 'date' || input.type === 'datetime-local');
}

const updateTextArea: (input: HTMLTextAreaElement) => void = (area) => {
  area.style.height = (area.scrollHeight - 28) + "px";
};

export default class extends Controller {
  private tomSelects: TomSelect[] = [];

  connect(): void {
    this.element.querySelectorAll("input, textarea").forEach((input) => {
      updateInput(input as HTMLInputElement);
    });
    this.element.querySelectorAll("textarea").forEach((input) => {
      updateTextArea(input);
    });

    this.element.querySelectorAll("select[data-autocomplete]").forEach((e) => {
      const element = e as HTMLInputElement;
      this.tomSelects.push(new TomSelect(element, {
        create: true,
        load: async (query: string, callback: (data: Array<{ value: string, text: string }>) => void) => {
          const response = await fetch(`${element.dataset.autocomplete}?term=${query}`);
          const data: string[] = await response.json();
          callback(data.map((e) => ({ value: e, text: e })));
        }
      }));
    });

    this.element.querySelectorAll("select[data-tagging]").forEach((e) => {
      const element = e as HTMLSelectElement;
      this.tomSelects.push(new TomSelect(element, {
        create: true
      }));
    });
  }

  disconnect(): void {
    this.tomSelects.forEach((select) => {
      select.destroy();
    });
    this.tomSelects = [];
  }
}
